import { formatBasicDetails } from "components/Details/helper";
import TagComp from "themes/elements/Tag";
import style from "../../details.module.scss";
import TimelineComp from "themes/elements/Timeline";
import AvatarComp from "themes/elements/Avatar";
import utils from "utils/utils";

function ContentInfo(props) {
  const { selectedNews } = props;
  /**
   * @param {Object} selectedNews - The selected news item to format.
   * @returns {Object} The formatted basic details of article.
   * Status, Image caption, Author, Recipients, Source, Created date, Expiry date & time
   */
  const basicInformation = formatBasicDetails(selectedNews);

  return (
    <>
      <div className={style["basic-info-wrapper"]}>
        {/* Basic information title */}
        <h4 className={style["card-title"]}>Basic information:</h4>
        {basicInformation.map(
          (detail, index) =>
            detail.value &&
            !utils.isEmpty(detail.value) && (
              <div key={index} className={style["detail-container"]}>
                {/* contentInfo titles : Status, Image caption:,
                   Author, Recipients, Source, Created date, Expiry date & time*/}
                <h5 className={style["detail-key"]}>{detail.key}:</h5>
                {Array.isArray(detail.value) ? (
                  <div className={style["detail-key-list"]}>
                    {detail.value.map((item, i) => (
                      /* Status, Recipients */
                      <TagComp key={i}>{item}</TagComp>
                    ))}
                  </div>
                ) : (
                  <div className="flex align-center gap-1">
                    {detail.avatar &&
                      (selectedNews?.author_image ? (
                        /* Author image */
                        <span className={style["avatar-img"]}>
                          <img src={selectedNews?.author_image} alt="avatar" />
                        </span>
                      ) : (
                        /*Author avatar : first letter of author name*/
                        <AvatarComp blue>
                          {selectedNews?.author?.slice(0, 1).toUpperCase()}
                        </AvatarComp>
                      ))}
                    {/* Author name */}
                    <h6 className={style["detail-value"]}>{detail.value}</h6>
                  </div>
                )}
              </div>
            )
        )}
      </div>
      {/* Activity Log time line */}
      <div className={style["basic-info-wrapper"]}>
        <h4 className={style["card-title"]}>Activity log:</h4>
        <TimelineComp timelineData={selectedNews?.activity} />
      </div>
    </>
  );
}

export default ContentInfo;
